import React, { Component } from 'react';
import { withNamespaces } from "react-i18next";
import { Row,Col  } from "reactstrap";


class Loader extends Component {
    

    render(){
       
       
        return(
            <React.Fragment>
                 <Row className="loader">
            <Col className="loader">
            <div className="spinner-border text-primary m-1" role="status">
                      <span className="sr-only"> { this.props.t("LOADING...") }</span>
            </div>
            </Col>
          </Row>

            </React.Fragment>
        )
    }
}

export default withNamespaces()(Loader)